var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"year"}},[_c('router-view',{attrs:{"year":_vm.$route.params.year}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }